import type { SxProps, Theme } from "@mui/material/styles";

import { Box, Typography } from "@mui/material";

/**
 * MUI `Stack` `spacing` between sibling drawer sections whenever a `divider` is
 * used (outer modules and inner Facility/Credential, Status/Notes, etc.).
 */
export const drawerSectionStackSpacing = 3;

/** Two-column readout / form grid shared by Facility, Credential, and status rows. */
export const drawerTwoColumnGridSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  columnGap: 2,
  rowGap: 1.5,
};

/** Borderless section shell for the credential drawer (divider + spacing live on parent `Stack`). */
export function DrawerSection({ title, children }: { title?: string; children: React.ReactNode }) {
  return (
    <Box>
      {title ? (
        <Typography variant="subtitle2" sx={{ mb: 2.5 }}>
          {title}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
